import { render, staticRenderFns } from "./rega.vue?vue&type=template&id=4f41387d&scoped=true"
import script from "./rega.vue?vue&type=script&lang=js"
export * from "./rega.vue?vue&type=script&lang=js"
import style0 from "./rega.vue?vue&type=style&index=0&id=4f41387d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f41387d",
  null
  
)

export default component.exports